/**
 * 创建人：zll
 * 时间：2021-9-07
 * 描述：内容指导组件
 * 使用说明: 参考 sw-intro 配置应用说明文档 
 * 更新记录: 
 */
import { Component, OnInit, Input, forwardRef, Output, EventEmitter, HostListener, ElementRef, ViewChild } from '@angular/core';
import IntroJs from 'src/assets/Scripts/intro/intro.js'

declare var $: any;

/**
 * 内容指导 sw-intro
 */
@Component({
  selector: 'sw-intro',
  templateUrl: './sw-intro.component.html',
  styleUrls: ['./sw-intro.component.css']
})
export class swIntroComponent implements OnInit {
 
  introObj:any = {}
  introObjId:string=''
  options:any
  // 1.设置步骤数 格式为：  steps = [ {element: '.a11',intro:'kkkk',title:'Welcome1111111',step:'1',position: 'bottom'}]
  // 2.一般格式 为：  steps = [ {element: '.a11',intro:'kkkk',title:'Welcome1111111',position: 'bottom'}]
  @Input() steps: any = []; // 引导步骤
  @Input() prevLabel: string = "上一步"; // 返回上一步的按钮的字符串 
  @Input()  nextLabel: string = "下一步"; // 返回下一步的按钮的字符串
  @Input()  skipLabel: string = '跳过'; // 跳过引导的按钮的字符串
  @Input()  doneLabel: string = '"结束"'; // 结束按钮的字符串
  @Input()  noRemindLabel: string = '不再提醒'; // 不再提醒按钮的字符串
  @Input()  showBullets: boolean = false;  // 未知
  @Input()  highlightClass: string = 'introjs';  // 高亮所使用的class名
  @Input()  hidePrev: boolean = true;  // 是否在第一步隐藏上一步
  @Input()  hideNext: boolean = true;  // 是否在最后一步隐藏下一步
  @Input()  showStepNumbers: boolean = false;  // 是否显示当前步骤的索引数字
  @Input() scrollToElement: boolean = true;  // 未知
  // @Input() showButtons: boolean = true;  // 是否显示所有按钮
  @Input() disableInteraction: boolean = false;  // 引导框内视图是否可交互
  @Input() tooltipClass: string = 'intro-no-pre';  // 提示框所使用的class名  当为  hideToolTipButton 表示隐藏所有按钮
  @Input() showProgress: boolean = false; // 是否显示进度条
  // @Input() overlayOpacity: number = 0.5;  // 蒙版的透明度
  @Input() exitOnEsc: boolean = false; // 是否使用键盘Esc退出
  @Input() exitOnOverlayClick: boolean =false; // 是否允许点击空白处退出
  // @Input() helperElementPadding: number;  // 提示边框的padding

  
  /**
   * 选中事件抛出
   */
  @Output() change = new EventEmitter()

  /**
    * 输出属性,清空后,将将清空值传递给父组件
    */
   @Output() clearClick = new EventEmitter();

   /**
    * 输出属性,不再提醒
    */
   @Output() noRemindClick = new EventEmitter();
  /**
   * 鼠标放到输入框上显示日期
   */
  dateValue:string = ""

  /**
   * 输入框
   */
  @ViewChild('input') input:ElementRef;
  
   

   /**
    * @ignore
    */
  constructor(
    private el: ElementRef
  ) {
    // setInterval(()=>{
   // this.jeDateId = "jedate" + Math.random().toString().split(".")[1];
    //this.jeDateIdShow = "jeDateIdShow" + Math.random().toString().split(".")[1];
    // },100)
  }

 
  /**
   * @ignore
   */
  ngOnInit() {
    this.introObjId = "introObj" + Math.random().toString().split(".")[1]
  }

  /**
   * @ignore
   */
  ngAfterViewInit(): void {
    // setTimeout(()=>{
    //   this.initType()
    // })
    
  }

  ngOnDestroy(): void {
    if(this.introObj[this.introObjId]){
      this.introObj[this.introObjId].exit()
    }
  }

  /**
   * @ignore
   */
 
  initType(){
    let that = this
    this.introObj[this.introObjId] =new IntroJs()
    this.introObj[this.introObjId].setOptions({
    prevLabel: this.prevLabel,
    nextLabel: this.nextLabel,
    skipLabel: this.skipLabel,
    doneLabel: this.doneLabel,
    noRemindLabel: this.noRemindLabel,
    showBullets: this.showBullets,
    highlightClass: this.highlightClass,
    hidePrev: this.hidePrev,
    hideNext: this.hideNext,
    showStepNumbers: this.showStepNumbers,
    scrollToElement: this.scrollToElement,
    disableInteraction: this.disableInteraction,
    tooltipClass:this.tooltipClass, // 该类名隐藏操作按钮（自定义） 
    showProgress: this.showProgress,
    overlayOpacity: 0.5,
    exitOnEsc: this.exitOnEsc,
    exitOnOverlayClick: this.exitOnOverlayClick,
    helperElementPadding: 1,
    steps:this.steps
    })
    this.introObj[this.introObjId].oncomplete(function() {

  }).onexit(function() {

  }).onbeforeexit(function() {

  }).onchange(function(targetElement) {

  }).onbeforechange(function(targetElement) {
  
  }).onafterchange(function(targetElement) {

  }).onremind(function(targetElement) {
    //  console.log('不再提醒')
    that.noRemindClick.emit(true)
  })
  this.introObj[this.introObjId].start()
}

// 跳转到第几步
goToStep(num:number) {
  this.initType()
  this.introObj[this.introObjId].goToStep(num)
}

//根据传入steps中 step 值，跳转
goToStepByNum(num:number) {
  this.initType()
  this.introObj[this.introObjId].goToStepNumber(num)
}

close(){
  if(this.introObj[this.introObjId]){
    this.introObj[this.introObjId].exit()
  }
}
  
  /**
   * 构子
   * @ignore
   */
  ngOnChanges(event): void {
   

  }





  
 

 


 

  
}